import * as Yup from "yup";

export const loginFormValidationSchema = Yup.object().shape({
  email: Yup.string()
    .required("O campo e-mail é obrigatório")
    .email("Por favor, insira um e-mail válido")
    .trim(),
  password: Yup.string().required("O campo senha é obrigatório").trim(),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "As senhas digitadas não coincidem"
  ),
});
